import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=d2712b54&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/products.css?vue&type=style&index=0&id=d2712b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2712b54",
  null
  
)

export default component.exports